module.exports = __webpack_public_path__ + "static/media/coliseu_box_1.0e7564f2.jpg";